import { ClassRegisterApiFactory, SchoolEventMapping } from '../../api/v2';
import { MNSproCloudApi } from '../..';

const generateApi = (authToken: string) => {
  const config = MNSproCloudApi.V2.createConfiguration(authToken);
  return ClassRegisterApiFactory(config);
};

export class HideAbsenceReasonsService {
  static async getHideAbsenceReasons(
    authToken: string,
    organizationId: string,
  ): Promise<SchoolEventMapping[]> {
    const api = generateApi(authToken);
    const result = await api.getSchoolEventMappings(organizationId);

    return result.data.mappings || [];
  }

  static async updateHideAbsenceReasons(
    authToken: string,
    organizationId: string,
    hideAbsenceReasons: SchoolEventMapping[],
  ): Promise<SchoolEventMapping[]> {
    const api = generateApi(authToken);
    const result = await api.updateSchoolEventMappings(
      organizationId,
      hideAbsenceReasons,
    );

    return result.data.mappings || [];
  }
}
